import { Component, OnInit, OnDestroy } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';

import { StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components/step-indicator';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { AdobeAnalyticsService, AuthenticationService, UtilityService } from 'lib/ng2-sapmp/src/providers';
import { UserWizardService } from 'lib/ng2-sapmp/src/providers';
import { UserWizardModel, UserProfileModel } from 'lib/ng2-sapmp/src/models';
import { UserWizardDataService } from './../users-wizard-data-service';
import { UserWizardProductModel, ProductModel } from './../shared';
import { DropdownModel } from 'lib/ng2-sapmp/src/ui-components/dropdown';
import { RequestModel } from './request-model';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { ANALYTICS_CONSTANTS, PIVOTS } from 'config';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot/mobile-pivot.model';

declare var logoutCurrentUser: any;

@Component({
  selector: 'app-manage-products-action',
  providers: [UserWizardDataService],
  templateUrl: './products.component.html',
  styleUrls: ['./../manage-users.component.scss']
})
export class ProductsComponent implements OnInit, OnDestroy {
  userWizardModel: UserWizardModel;
  userWizardProductModel: UserWizardProductModel;
  selectedDropDown: DropdownModel[];
  productModel: ProductModel;
  productModelList: ProductModel[];
  isContinueValid: boolean;
  errorMessage: string;
  requestModel: RequestModel;
  user: UserProfileModel;
  pivots: Array<MobilePivotModel>;
  isProductAvailable: boolean;
  errorFlag = false;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private stepindicatorService: StepIndicatorService,
    private userWizardService: UserWizardService,
    private utilityService: UtilityService,
    private userWizardDataService: UserWizardDataService,
    private breadCrumbService: BreadCrumbService, private pageloaderService: PageLoaderService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private authenticationService: AuthenticationService) {
    this.userWizardProductModel = new UserWizardProductModel();
    this.userWizardModel = new UserWizardModel();
    this.productModelList = [];
    this.isContinueValid = false;
    this.pivots = new Array<MobilePivotModel>();
  }


  // Data From Session --> this.userWizardModel
  // List of available products ---> this.userWizardProductModel

  ngOnInit() {
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    if (sessionStorage.getItem('assign-wizard') === null || !!!this.userWizardService.fetchSessionData().actionType) {
      this.router.navigate(['/home']);
    } else {
      // document.title = 'AT&T Business Console - Manage users - Products';
      document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
      this.pageloaderService.setPageLoaderStatus(false);
      this.stepindicatorService.setCurrentStep(this.activatedRoute.snapshot.url[0].path);
      this.userWizardModel = this.userWizardService.fetchSessionData();
      if (PIVOTS[this.userWizardModel.previousUrl]) {
        this.pivots.push({ label: PIVOTS[this.userWizardModel.previousUrl], routerLink: this.userWizardModel.previousUrl });
      }
      this.pivots.push({ label: 'Console dashboard', routerLink: '/dashboard' });
      this.userWizardService.setPivot(this.pivots);
      const message = this.userWizardModel.actionType === 'ASSIGN' ? 'Assign product licenses' : 'Un-assign product licenses';
      this.userWizardService.setMessage(message);
      this.user = JSON.parse(sessionStorage.getItem('user')).user;

      this.requestModel = new RequestModel();
      this.requestModel.fetchCriteria = {
        'class': 'API::SepPagingLoadConfig', 'limit': 10, 'offset': 0,
        'sortDir': 'DESC', 'sortField': 'name'
      };
      this.requestModel.class = 'API::ServiceOfferingCriteria';
      this.requestModel.excludeAddons = true;
      if (this.userWizardModel.actionType === 'ASSIGN') {
        this.requestModel.withAvailableLicenses = true;
      } else {
        this.requestModel.withAssignedLicenses = true;
      }
      // this.requestModel.excludeProductsWithZeroAvailableLicenses = true;
      // this.requestModel.catalogStatus = 'ACTIVE'; // ToDo finalized

      this.userWizardDataService.getProductDetails(this.user.companyId, this.requestModel).subscribe(response => {
        if (response && response.totalLength > 0) {
          this.isProductAvailable = true;
          this.userWizardModel.productList = response;
          this.userWizardProductModel = this.userWizardDataService.populateProductData(this.userWizardModel);
          if (this.userWizardModel.source === 'product') {
            if (this.userWizardModel.selectedProductList && this.userWizardModel.selectedProductList.length > 0) {
              this.populateSingleSelectedProductList();
            } else {
              this.populateSingleSelectedProduct();
            }
          } else if (this.userWizardModel.source === 'user') {
            this.populateHideSingleSelectedProductFromUser();
            if (this.userWizardModel.selectedProductList && this.userWizardModel.selectedProductList.length > 0) {
              this.populatePreSelectedProduct();
            }
            this.pageloaderService.setPageLoaderStatus(true);
          } else if (this.userWizardModel.selectedProductList && this.userWizardModel.selectedProductList.length > 0) {
            this.populatePreSelectedProduct();
            this.pageloaderService.setPageLoaderStatus(true);
          }
          this.isContinueButtonValid();
          if (this.userWizardModel.source === undefined) {
            this.pageloaderService.setPageLoaderStatus(true);
          }
          if (this.userWizardProductModel.product && this.userWizardProductModel.product.length > 0) {
            const isSelectedProductIndex = this.userWizardProductModel.product.filter(data => (data.isHidden));
            if (isSelectedProductIndex.length === this.userWizardProductModel.product.length) {
              this.errorMessage = 'No product licenses are available to '
                + (this.userWizardModel.actionType === 'ASSIGN' ? 'assign' : 'un-assign')
                + 'ed.';
              this.isProductAvailable = false;
              this.pageloaderService.setPageLoaderStatus(true);
              this.errorFlag = true;
            }
          }
        } else {
          if (response && response.totalLength === 0) {
            this.errorMessage = 'No product licenses are available to '
              + (this.userWizardModel.actionType === 'ASSIGN' ? 'assign' : 'un-assign')
              + 'ed.';
            this.isProductAvailable = false;
            this.errorFlag = true;
          }
          this.pageloaderService.setPageLoaderStatus(true);
        }
      }, error => {
        this.isProductAvailable = false;
        this.pageloaderService.setPageLoaderStatus(true);
        this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
        this.handleError(error);
      });
      this.userWizardDataService.createPageLoadProperties([],
        this.router.routerState.snapshot.url, 'Manageusers Page - Step2',
        ANALYTICS_CONSTANTS.FRIENDLY_NAME_MANAGE_USER_PRODUCTS);
    }
  }

  nextStep() {

    if (this.userWizardModel.selectedUserList) {
      let isAlreadySelectedProduct: boolean;

      isAlreadySelectedProduct = this.productModelList.length === this.userWizardModel.selectedProductList.length ? true : false;

      if (isAlreadySelectedProduct) {
        for (const currentlySelectedProduct of this.productModelList) {
          const sameData = this.userWizardModel.selectedProductList.filter(preSelectedProduct => (
            (preSelectedProduct.dcmCode === currentlySelectedProduct.dcmCode) &&
            (preSelectedProduct.selectedFan === currentlySelectedProduct.selectedFan) &&
            (preSelectedProduct.selectedCtn === currentlySelectedProduct.selectedCtn)));
          if (sameData.length === 0) {
            isAlreadySelectedProduct = false;
            break;
          }
        }
      }
      if (!isAlreadySelectedProduct) {
        console.log('Deleted');
        delete this.userWizardModel.userList;
        delete this.userWizardModel.selectedUserList;
        delete this.userWizardModel.selectedUsersIds;
      }
    }
    /* let tempObject = Object.create(this.productModelList[0]);
    tempObject['dcmCode'] ='AMSFL010';
    tempObject['productName'] ='Pipedrive - Silver';
    tempObject['clientId'] ='ldc6iuFQcvupORlZ1A9ZlMErgiF07kMPaR87';
    this.productModelList.push(tempObject); */
    this.userWizardModel.selectedProductList = [];
    this.userWizardModel.selectedProductList = (this.productModelList);
    this.userWizardService.addProductList(this.userWizardModel);
    this.router.navigate(['/manageUsers/users'], { relativeTo: this.activatedRoute });
  }

  cancel() {
    // this.stepindicatorService.removeStep('manageUsers');
    // this.userWizardDataService.cancel(this.userWizardModel.previousUrl);
    this.router.navigate(['/manageUsers/action'], { relativeTo: this.activatedRoute });
  }

  private getProductsDetial(checked, rowIndex) {
    if (checked) {
      this.pageloaderService.setPageLoaderStatus(false);
      this.userWizardProductModel.product[rowIndex].isChecked = checked;

      this.userWizardDataService.getFanAndCtnList('', this.user.companyId,
        this.userWizardProductModel.product[rowIndex].dcmCode).subscribe(response => {
          let productModelObject = new ProductModel();
          productModelObject = this.userWizardDataService.populateFan(this.userWizardProductModel.product[rowIndex], response,
            this.userWizardProductModel.product[rowIndex].dcmCode, this.userWizardModel.actionType);
          this.userWizardProductModel.product[rowIndex] = productModelObject;
          // tslint:disable-next-line:max-line-length
          if ((response && response.accountSummaries && response.accountSummaries.length === 0) || (this.userWizardProductModel.product[rowIndex].fan.length === 1)) {
            this.addDisabledProperty(rowIndex);
          }
          this.pageloaderService.setPageLoaderStatus(true);
        }, error => {
          this.pageloaderService.setPageLoaderStatus(true);
          this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
          this.handleError(error);
        });
    } else {
      this.removeSelectedProduct(this.userWizardProductModel.product[rowIndex].dcmCode);
      this.userWizardProductModel.product[rowIndex].isChecked = checked;
      this.userWizardProductModel.product[rowIndex].selectedFan = 'Select';
      this.userWizardProductModel.product[rowIndex].selectedCtn = 'Select';
      this.userWizardProductModel.product[rowIndex].ctnMapObject = undefined;
      this.userWizardProductModel.product[rowIndex].fan = [];
      this.userWizardProductModel.product[rowIndex].ctn = [];
    }
    this.isContinueButtonValid();
  }

  private selectedFanDropDown(selectedValue: DropdownModel, rowIndex) {
    this.userWizardProductModel.product[rowIndex].selectedFan = selectedValue.value;
    this.userWizardProductModel.product[rowIndex].selectedCtn = 'Select';
    if (selectedValue.value !== 'Select') {
      this.getCtnListBasedOnFan(selectedValue.value, this.userWizardProductModel.
        product[rowIndex].ctnMapObject, rowIndex);
    }
    this.removeSelectedProduct(this.userWizardProductModel.product[rowIndex].dcmCode);
    this.isContinueButtonValid();
  }

  private selectedCtnDropDown(ctnSelectedValue: DropdownModel, rowIndex) {
    this.userWizardProductModel.product[rowIndex].selectedCtn = ctnSelectedValue.value;
    if (ctnSelectedValue.value !== 'Select') {
      this.getClientID(this.userWizardProductModel.product[rowIndex].selectedFan, ctnSelectedValue.name,
        this.userWizardProductModel.product[rowIndex].dcmCode, rowIndex);
    } else {
      this.userWizardProductModel.product[rowIndex].clientId = '';
      this.removeSelectedProduct(this.userWizardProductModel.product[rowIndex].dcmCode);
      this.isContinueButtonValid();
    }
  }

  // Single product or Product management scenarios
  private populateSingleSelectedProduct() {
    let index = 0;
    for (const productModel of this.userWizardProductModel.product) {
      if (productModel.dcmCode === this.userWizardModel.product.dcmCode) {
        this.userWizardProductModel.product[index].isHidden = false;
        this.userWizardProductModel.product[index].selectedFan = this.userWizardModel.product.fan;
        this.userWizardProductModel.product[index].selectedCtn = this.userWizardModel.product.ctn;
        this.userWizardProductModel.product[index].clientId = this.userWizardModel.product.clientId;
        this.userWizardProductModel.product[index].totalLicensesAvailable = this.userWizardModel.product.totalLicensesAvailable;
        this.userWizardProductModel.product[index].licensegroupName = this.userWizardModel.product.licensegroupName;
        this.userWizardProductModel.product[index].totalLicensesInUse = this.userWizardModel.product.totalLicensesInUse;
        this.userWizardProductModel.product[index].fan = productModel.fan;
        this.userWizardProductModel.product[index].isChecked = true;
        this.userWizardProductModel.product[index].ctn = [];
        this.populateCtnListbasedonPrepopulatedFan(productModel.dcmCode, this.user.companyId, index);
        this.addSelectedProduct(productModel.dcmCode, index);
      } else {
        this.userWizardProductModel.product[index].isHidden = true;
      }
      index++;
    }
  }
  private populateSingleSelectedProductList() {
    const preSelectedProductList = this.userWizardModel.selectedProductList;
    let index = 0;
    for (const value of this.userWizardProductModel.product) {
      preSelectedProductList.forEach(selectedProduct => {
        if (value.dcmCode === selectedProduct.dcmCode) {
          this.userWizardProductModel.product[index] = Object.assign(new ProductModel(), selectedProduct);
          this.populateCtnListbasedonPrepopulatedFan(value.dcmCode, this.user.companyId, index);
          this.addSelectedProduct(selectedProduct.dcmCode, index);
        } else {
          this.userWizardProductModel.product[index].isHidden = true;
        }
      });
      index++;
    };
  }
  /**
   * This method purpose to hide already assigned Products
   */
  private populateHideSingleSelectedProductFromUser() {
    let index = 0;

    for (const existProductCode of this.userWizardModel.existingProducts) {
      index = 0;
      for (const productModel of this.userWizardProductModel.product) {
        if (productModel.dcmCode === existProductCode) {
          this.userWizardProductModel.product[index].isHidden = true;
        }
        index++;
      }
    }
  }

  private getCtnListBasedOnFan(fan: string, ctnMap, rowIndex: number) {
    try {
      if (ctnMap) {
        this.userWizardProductModel.product[rowIndex].ctn = this.userWizardDataService.populateCtnList
          (ctnMap.get(fan), this.userWizardModel.actionType);
        if (this.userWizardProductModel.product[rowIndex].selectedCtn !== 'Select') {
          const isCtnExist = this.userWizardProductModel.product[rowIndex].ctn.filter(data => (data.value ===
            this.userWizardProductModel.product[rowIndex].selectedCtn));
          if (isCtnExist.length === 0) {
            this.userWizardProductModel.product[rowIndex].selectedCtn = 'Select';
            this.userWizardProductModel.product[rowIndex].clientId = '';
            this.removeSelectedProduct(this.userWizardProductModel.product[rowIndex].dcmCode);
            this.isContinueButtonValid();
          }
        }
      }
    } catch (exception) {
      console.log(exception);
    }
  }

  private addSelectedProduct(dcmCode: string, rowIndex: number) {
    let isExist = new ProductModel();
    isExist = this.productModelList.find((data) => data.dcmCode === dcmCode);
    if (isExist) {
      let findIndex = 0;
      this.productModelList.forEach((data, index) => {
        if ((data.dcmCode === dcmCode)) {
          findIndex = index;
        }
      });
      this.productModelList[findIndex] = Object.assign(new ProductModel(), this.userWizardProductModel.product[rowIndex]);
    } else {
      this.productModel = Object.assign(new ProductModel(), this.userWizardProductModel.product[rowIndex]);
      this.productModelList.push(this.productModel);
    }
  }

  private removeSelectedProduct(dcmCode) {
    let removeIndex: number;
    this.productModelList.forEach((data, index) => {
      if ((data.dcmCode === dcmCode)) {
        removeIndex = index;
      }
    });
    if (removeIndex !== undefined) {
      this.productModelList.splice(removeIndex, 1);
    }
  }

  /** This method is Not applicable for Single Selected product or Product management scenarios and manage users
   * for already assigned product.
  **/
  private populatePreSelectedProduct() {
    const preSelectedProductList = this.userWizardModel.selectedProductList;
    let index = 0;
    for (const value of this.userWizardProductModel.product) {
      preSelectedProductList.forEach(selectedProduct => {
        if (value.dcmCode === selectedProduct.dcmCode) {
          this.userWizardProductModel.product[index] = Object.assign(new ProductModel(), selectedProduct);
          this.populateCtnListbasedonPrepopulatedFan(value.dcmCode, this.user.companyId, index);
          this.addSelectedProduct(selectedProduct.dcmCode, index);
        }
      });
      index++;
    };
  }
  private isContinueButtonValid() {
    const isChecked = this.userWizardProductModel.product.filter(data => ((data.isChecked))).length;
    if (isChecked) {
      this.isContinueValid = (this.productModelList.length === isChecked) ? true : false;
    } else {
      this.isContinueValid = false;
    }
  }

  private handleError = (error) => { // Arrow function is necessary as the context should be Parent class
    if (error) {
      if (error.status === 401) {
        this.errorMessage = 'Session expired.Please login again.';
        logoutCurrentUser(true);
      } else {
        this.errorMessage = 'We couldn\'t complete your request. Please try again later.';
      }
      this.utilityService.loadFocusOnTop();
    } else {
      throw error;
    }
  }

  private populateCtnListbasedonPrepopulatedFan(dcmCode: string, companyId: string, rowIndex) {
    this.pageloaderService.setPageLoaderStatus(false);
    const value = this.userWizardDataService.getFanAndCtnList('', companyId, dcmCode);
    if (value) {
      value.subscribe(response => {
        let productModelObject = new ProductModel();
        productModelObject = this.userWizardDataService.populateFan(this.userWizardProductModel.product[rowIndex],
          response, this.userWizardProductModel.product[rowIndex].dcmCode, this.userWizardModel.actionType);
        this.userWizardProductModel.product[rowIndex] = productModelObject;
        // tslint:disable-next-line:max-line-length
        if ((response && response.accountSummaries && response.accountSummaries.length === 0) || (this.userWizardProductModel.product[rowIndex].fan.length === 1)) {
          this.addDisabledProperty(rowIndex);
        } else if (this.userWizardProductModel.product[rowIndex].selectedFan !== 'Select') {
          const isFanExist = this.userWizardProductModel.product[rowIndex].fan.filter(data => (data.value ===
            this.userWizardProductModel.product[rowIndex].selectedFan));
          if (isFanExist.length === 0) {
            this.userWizardProductModel.product[rowIndex].selectedFan = 'Select';
            this.userWizardProductModel.product[rowIndex].selectedCtn = 'Select';
            this.removeSelectedProduct(this.userWizardProductModel.product[rowIndex].dcmCode);
            this.isContinueButtonValid();
          }
          this.getCtnListBasedOnFan(this.userWizardProductModel.product[rowIndex].selectedFan, productModelObject.ctnMapObject, rowIndex);
        }
        this.pageloaderService.setPageLoaderStatus(true);
      }, error => {
        this.pageloaderService.setPageLoaderStatus(true);
        this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
        this.handleError(error);
      });
    }
  }

  private getClientID(fan: string, billingClientId: string, dcmCode: string, rowIndex) {
    this.pageloaderService.setPageLoaderStatus(false);
    this.requestModel = new RequestModel();
    this.requestModel.fetchCriteria = { 'limit': 20, 'offset': 0, 'sortDir': 'ASC', 'sortField': 'serviceOfferingName' };
    this.requestModel.serviceStatus = 'ACTIVE';
    this.requestModel.brokerAccountClientIds = [];
    this.requestModel.brokerAccountClientIds.push(fan);
    this.requestModel.serviceOfferCodes = [];
    this.requestModel.serviceOfferCodes.push(dcmCode);
    this.requestModel.billingClientId = billingClientId;
    this.userWizardDataService.getClientId(this.requestModel, this.user.companyId).subscribe(response => {
      if (response && response.dataJson) {
        const clientObj = this.userWizardDataService.populateClientId(response);
        console.log('clientId--------------' + clientObj.clientId + '------------totalLicensesAvailable------'
          + clientObj.availabilityCount);
        if (clientObj) {
          this.userWizardProductModel.product[rowIndex].clientId = clientObj.clientId;
          this.userWizardProductModel.product[rowIndex].totalLicensesAvailable = clientObj.availabilityCount;
          this.userWizardProductModel.product[rowIndex].licensegroupName = clientObj.licensegroupName;
          this.userWizardProductModel.product[rowIndex].totalLicensesInUse = clientObj.licenseInUse;
          this.addSelectedProduct(this.userWizardProductModel.product[rowIndex].dcmCode, rowIndex);
        } else {
          this.removeSelectedProduct(this.userWizardProductModel.product[rowIndex].dcmCode);
        }
      } else {
        this.removeSelectedProduct(this.userWizardProductModel.product[rowIndex].dcmCode);
      }
      this.isContinueButtonValid();
      this.pageloaderService.setPageLoaderStatus(true);
    }, error => {
      this.removeSelectedProduct(this.userWizardProductModel.product[rowIndex].dcmCode);
      this.isContinueButtonValid();
      this.pageloaderService.setPageLoaderStatus(true);
      this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
      this.handleError(error);
    });
  }

  private redirectToBuyNow(product: any) {
    sessionStorage.removeItem('mappingFanData');
    const license = { 'key': product.productName, 'serviceOfferCode': product.dcmCode };
    sessionStorage.setItem('mappingFanData', JSON.stringify(license));
    sessionStorage.removeItem('assign-wizard');
    const rowIndex = this.breadCrumbService.getBreadCrumbs().findIndex((data) => (data.routerLink === '/manage'));
    if (rowIndex !== undefined && rowIndex !== null && rowIndex > 0) {
      this.breadCrumbService.removeSessionBreadCrumbProperty(rowIndex + 1);
    } else {
      this.breadCrumbService.removeLastBreadCrumb();
    }
    this.router.navigate(['/licensesBuyProduct']);
  }

  private addDisabledProperty(rowIndex) {
    this.removeSelectedProduct(this.userWizardProductModel.product[rowIndex].dcmCode);
    this.userWizardProductModel.product[rowIndex].isDisabled = true;
    this.userWizardProductModel.product[rowIndex].isChecked = false;
    this.userWizardProductModel.product[rowIndex].selectedFan = 'Select';
    this.userWizardProductModel.product[rowIndex].selectedCtn = 'Select';
    this.userWizardProductModel.product[rowIndex].ctnMapObject = undefined;
    this.userWizardProductModel.product[rowIndex].fan = [];
    this.userWizardProductModel.product[rowIndex].ctn = [];
    this.isContinueButtonValid();
  }

  ngOnDestroy() {
    this.pageloaderService.setPageLoaderStatus(true);
  }
}
